import { makeMetricListItem } from '../MetricListItem';

export const OverviewSiteReadingDetailsMetricListItem = makeMetricListItem(
    (value) => value.channelName,
    (value) => value.deviceName
);
